import React from 'react'
import { CustomDialogContent } from '..'
import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core'

interface IWhatIsDailyDoseModalProps {
  onCloseInfoModal: () => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      lineHeight: 2,
      textAlign: 'justify',
      margin: theme.spacing(2, 0),
    },
    strong: {
      fontWeight: 'bold',
    },
  })
)

export const WhatIsDailyDoseModal = ({
  onCloseInfoModal,
}: IWhatIsDailyDoseModalProps) => {
  const classes = useStyles()
  return (
    <CustomDialogContent title="What is the daily dose?" onCancel={onCloseInfoModal}>
      <Typography variant="h5" className={classes.contentContainer}>
        The WHAT
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        The daily dose is the app that will help you break the routine of those
        lockdown days and will allow you to share moments, create experiences and
        challenge your friends so you can make your days look a bit different.
      </Typography>
      <Typography variant="h5" className={classes.contentContainer}>
        The HOW
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        With the daily dose you will be able to encapsulate those experiences in the
        form of doses. A dose is something you want you and your friends to do, to
        share, to react to, or anything you think will break yours and their
        routines.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        For example: count how many steps you take to go to the grocery store.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        To be able to share a dose with your friends you will need to create your
        daily dose group, we call those your groups.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        A person that is part of a group is a doser. Any doser can add doses to the
        groups he/she is part of.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        Once one or more doses are added then the fun begins:. The app will pick up
        randomly one of the doses from the group pool and show it in the{' '}
        <span className={classes.strong}>{`Today's Dose`}</span> menu.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        Once the dose is available you will have the chance to use that dose as a
        disruptive moment for that day and share your experience with your friends.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        Imagine you are challenged to do a little run for a change, or that a friend
        wants to organize a virtual dinner that day and you can all come together!
        The possibilities are <span className={classes.strong}>limitless!</span>
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        {`It's up to you at the end how you would like to engage with the dose, but
        it's a great opportunity to make your days at least less mundane and more`}
        colorful.
      </Typography>
    </CustomDialogContent>
  )
}
